import DataTable from 'components/Tables/DataTable'
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import { Routes, Route } from 'react-router-dom'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import { ShowUser } from './ShowUser'
import { UsersTable } from './components/UsersTable'
import styled from '@emotion/styled'
import { Box, Button, Card, Grid, Typography } from '@mui/material'
import { Add } from '@mui/icons-material'
import { useModal } from 'components/modals'

// Adding here for the swap to muiXpro
// import { LicenseInfo } from '@mui/x-license'
// //this is also an environment variable:
// // LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY!);
// LicenseInfo.setLicenseKey(
//   'd4f9055e631db90d3dac4b87737b348bTz0xMTU0MjIsRT0xNzgyOTUwMzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
// )

export const UsersList = () => {
  const { openModal } = useModal()
  return (
    <DashboardLayout>
      {/* <DashboardNavbar /> */}
      <Box
        px={{
          xs: 4,
          sm: 4,
          md: 4,
          lg: 6,
          xl: 6,
          xxl: 6,
          test: 6,
          xl3: 6,
        }}
        pb={6}
      >
        <Grid item xs={12} mb={2} mt={6}>
          <Box display="flex">
            <Typography
              variant="h1"
              fontWeight="600"
              fontSize="28px"
              textAlign="left"
              color="#262627"
              lineHeight={1.5}
            >
              PARCO Users
            </Typography>
            <Button
              rel="noreferrer"
              variant="parcoRounded"
              onClick={() => openModal('createUserModal')}
              startIcon={<Add />}
              sx={{
                marginLeft: '16px',
              }}
            >
              Create New User
            </Button>
          </Box>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Card
              sx={{
                textAlign: 'left',
                boxShadow: 0,
                borderRadius: 2,
                border: '1px solid #D2D6DA',
              }}
            >
              <div data-testid="userTableContainer">
                <UsersTable />
              </div>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </DashboardLayout>
  )
}
